import AktorerModal from "./AktorerModal";
import BybetjentCreateModal from "./Bybetjent";
import FargerModal from "./FargerModal";
import InternkoderModal from "./InternkoderModal";
import KjoretoyMerkerModal from "./KjoretoyMerkerModal";
import KjoretoyTyperModal from "./KjoretoyTyperModal";
import NasjonerModal from "./NasjonerModal";
import OvertredelseskoderIleggelser from "./OvertredelseskoderIleggelseModal";
import OvertredelseskoderMiljogebyr from "./OvertredelseskoderMiljogebyrModal";
import RettekoderModal from "./RettekoderModal";
import VedtakskoderModal from "./VedtakskoderModal";

export default function CreateModals({ createModalToRender }) {
  return (
    <div>
      {createModalToRender === "Aktører" && <AktorerModal />}
      {createModalToRender === "Bypatruljen" && <BybetjentCreateModal />}
      {createModalToRender === "Farger" && <FargerModal />}
      {createModalToRender === "Internkoder ileggelser" && (
        <InternkoderModal modalToRender="ileggelser" />
      )}
      {createModalToRender === "Internkoder miljøgebyr" && (
        <InternkoderModal modalToRender="miljøgebyr" />
      )}
      {createModalToRender === "Kjøretøytyper" && <KjoretoyTyperModal />}
      {createModalToRender === "Kjøretøymerker" && <KjoretoyMerkerModal />}
      {createModalToRender === "Nasjoner" && <NasjonerModal />}
      {createModalToRender === "Overtredelseskoder ileggelser" && (
        <OvertredelseskoderIleggelser />
      )}
      {createModalToRender === "Overtredelseskoder miljøgebyr" && (
        <OvertredelseskoderMiljogebyr />
      )}
      {createModalToRender === "Rettekoder" && <RettekoderModal />}
      {createModalToRender === "Vedtakskoder" && (
        <VedtakskoderModal modalToRender="vedtakskoder" />
      )}
    </div>
  );
}
